var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E10714;}\r\n\t.st1{fill:#020202;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.1,30.8c1.8,0,3.6,0,5.5,0c2.5,5.1,4.9,10.2,7.5,15.4c2-4.2,3.9-8.1,5.8-12.1c0.5-1.1,1.2-2.1,1.5-3.3 c1.7,0,3.4,0,5.1,0c0.5,0,0.6,0.1,0.6,0.6c0,9.1,0,18.2,0,27.3c0,0.5-0.1,0.6-0.6,0.6c-1.7,0-3.4,0-5.1,0c0-5.4,0-10.8,0-16.5 c-1.5,3-3,5.6-4.1,8.3c-0.8,2-2,2.7-4,2.4c-0.8-0.1-1.2-0.3-1.5-1c-1.4-2.9-2.9-5.9-4.4-8.8c-0.1-0.2-0.1-0.7-0.6-0.6 c0,0.6,0,1.2,0,1.8c0,4.8,0,9.6-0.1,14.3c-1.8,0-3.6,0-5.5,0C89.1,49.7,89.1,40.3,89.1,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.8,30.8c1.5,0,3,0,4.5,0c-0.2,0.5,0.2,1,0.4,1.4c3.3,9,6.6,18,9.9,27c-2,0-4,0-5.9,0 c-0.2-1.7-1-3.1-1.4-4.7c-0.1-0.4-0.5-0.3-0.8-0.3c-2.9,0-5.9,0-8.8,0c-0.4,0-0.7,0-0.9,0.5c-0.5,1.5-1,3-1.4,4.5 c-1.9,0-3.8,0-5.7,0c-0.1-0.4,0.1-0.7,0.2-1C64.1,49.1,67.5,39.9,70.8,30.8z M76.6,49.5c-1.2-3.4-2.3-6.8-3.5-10.3 c-1.2,3.6-2.4,6.9-3.6,10.3C71.9,49.5,74.2,49.5,76.6,49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15,44.3c0.3-0.1,0.2-0.4,0.3-0.6c0.6-1.6,1.9-2.5,3.6-2.5c6.9,0,13.8,0,20.8,0c2.2,0,3.8,1.7,3.8,3.8 c0,2.1-1.6,3.8-3.8,3.8c-6.9,0-13.8,0-20.8,0c-2.1,0-3.2-1.4-3.9-3.1C15,45.2,15,44.8,15,44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.8,30.8c0,0.3,0.1,0.5,0.1,0.8c0,8.9,0,17.9,0,26.8c0,0.3-0.1,0.5-0.1,0.8c-1.8,0-3.6,0-5.5,0 c0-9.5,0-19,0-28.5C53.2,30.8,55,30.8,56.8,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.4,30.8c2.5,1,3.4,2.5,3,4.6c-0.4,1.8-1.7,3-3.5,3.1c-3.6,0.1-7.2,0.1-10.8,0c-2,0-3.4-1.5-3.6-3.4 c-0.2-1.9,0.9-3.4,2.8-4.1c0.1,0,0.2-0.1,0.2-0.2C32.5,30.8,36.5,30.8,40.4,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15,55.2c0.2,0,0.2-0.2,0.2-0.3c0.5-2.2,1.8-3.4,4.1-3.4c3.2,0,6.4,0,9.6,0c2.2,0,3.8,1.4,4.1,3.3 c0.3,1.9-0.8,3.5-2.9,4.2c-0.1,0-0.1,0.1-0.1,0.2c-4,0-7.9,0-11.9,0c-1.7-0.7-2.6-2.1-3.1-3.8C15,55.4,15,55.3,15,55.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIam);
export default __webpack_public_path__ + "static/media/IAM.6009b5d02a7f98aa728a33f8cd21e085.svg";
export { ForwardRef as ReactComponent };